import React, { PropsWithChildren } from 'react';
import { HiddenInput } from '../../../../../../_lib/Form2/elements/HiddenInput/HiddenInput';
import Btn, { BtnModifier } from '../../../../Btn';
import { Icons } from '../../../../../atoms/SVG';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import { TopContentResult } from '../AbstractComboBox/types/SuggestResultTypes';

type GroupPreviewProps = PropsWithChildren<{
  id: string;
  title: string;
  name?: string;
  index: number;
  result: TopContentResult;
  reset(): void;
}>;

export function GroupPreview({ id, title, name, index, result, reset }: Readonly<GroupPreviewProps>) {
  const { t } = useSonTranslation('FormsComboBoxMultiSelect');

  return (
    <li className="forms-combobox-multiselect__list-item">
      <div className="forms-combobox-multiselect__selection">
        <p className="forms-combobox-multiselect__title" id={id}>
          {title}
        </p>
        <div className="forms-combobox-multiselect__interactions">
          <HiddenInput
            name={`${name}[${index}].id`}
            value={result.id}
          />
          <Btn
            modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
            svgSpriteId={Icons.DELETE_X_SMALL}
            type="button"
            text={t('resultlist.deleteButtonText', { itemName: result.title })}
            titleText={t('resultlist.deleteButtonTitleText', { itemName: result.title })}
            hiddenText
            tooltipPlacement={TooltipPlacement.LEFT}
            onClick={reset}
          />
        </div>
      </div>
    </li>
  );
}
